module.exports = __webpack_public_path__ + "4bb4ca3ba9b34a76239470926f819d03.gif";